// extracted by mini-css-extract-plugin
export var linkText = "_os-0";